export const chatbotConfig = {
  apiConfig: {
    endpoint: 'https://aichatbot.pangocdp.io/api/v1/prediction',
    modelId: 'd5f649a0-7e6a-4f2a-aaf3-3e4ed9afa944',
    token: 'gpLMkgtYEV8AeewvCvUsliA8OrEu8kRMW9PaiPNOzwc',
    overrideConfig: {
      returnSourceDocuments: true,
      streaming: true,
      sessionId: '' // Sẽ được set từ user đang login
    }
  }
} 